import { Divider } from 'antd'
import Switch from 'antd/lib/switch'
import Button from 'components/Button'
import EditIcon from 'components/icons/EditIcon'
import { FooterFlex } from 'modules/Drives/ViewDriveRole/BulkActionDrawer/ScheduleInterviewDrawer/InterviewerDrawer/style'
import {
  getNotificationCatalogues,
  sendInAppNotification,
  sendNotificationBulkEmail,
  sendNotificationBulkEmailWhatsapp,
} from 'modules/Users/actions'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import styled from 'styled-components'
import ErrorMessage from 'utils/ErrorMessage'
import { permittedEventCruds } from 'utils/permissionsValidation'
import {
  CheckboxItem,
  CustomStyledDrawer,
  DrivesButton,
  HeaderItem,
  HeaderRightItem,
  IconPointer,
  LeftHeaderItem,
  LisSubtHead,
  ListHead,
  ListItem,
  ParaText,
  RightHeaderItem,
  SubContent,
  SubHeaderItem,
  SubPara,
  TopHeader,
} from '../../BulkActionDrawer/ReqestDocument/Style'
import UploadDetailsDrawer from '../../BulkActionDrawer/ReqestDocument/UploadDocumentsDrawer/index'
import ConfirmDrawer from '../ReqestDocument/ConfirmDrawer/index'

const StyledDivider = styled(Divider)`
  ${({ isAddress }) =>
    isAddress
      ? `
        border-width: 0px;
        color: transparent;
        margin-top: 0px;
      `
      : `
        border-width: 1px;
        color: black;
        margin-top: 10px;
      `}
`
const RequestDocumentdrawer = ({
  setReqestDocumentDrawer,
  reqestDocumentDrawer,
  getRequestDocument,
  requestDocumentList,
  requestCandidateDocuments,
  setSelectedCandidateId,
  driveId,
  roleId,
  candidateIds,
  setSelectedCandidate,
  selectedCandidate,
  getRoleMetrics,
  rolesMetrics,
  isSingleOrBulk,
}) => {
  const dispatch = new useDispatch()
  const { STD_APP_URL } = process.env
  const corpData = useSelector(state => state?.auth?.corporateData)
  const permission = useSelector(state => state?.auth?.permissions)
  const [selectedDocType, setSelectedDocType] = useState(null)
  const [showUploadDetailsDrawer, setShowUploadDetailsDrawer] = useState(false)
  const [selectedDocuments, setSelectedDocuments] = useState([])
  const [isAddressSwitchOn, setIsAddressSwitchOn] = useState(false)
  const [isIdentityProofSwitchOn, setIsIdentityProofSwitchOn] = useState(false)
  const [confirmDrawer, setConfirmDrawer] = useState(false)
  const [addressSelectedDocuments, setAddressSelectedDocuments] = useState([])
  const [indentitySelectedDocuments, setIndentitySelectedDocuments] = useState(
    []
  )
  const [onAddressMandatory, setOnAddressMandatory] = useState(false)
  const [onIdentityMandatory, setOnIdentityMandatory] = useState(false)
  const [reqDocWhatsapp, setReqDocWhatsapp] = useState(null)
  const [reqDocEmail, setReqDocEmail] = useState(null)
  const permittedEvents = permittedEventCruds(
    permission,
    'Evaluation Process - Experienced Candidate'
  )
  const Schedule =
    permittedEvents?.find(item => item.events?.eventName === 'VIEW')?.events ||
    ''
  useEffect(() => {
    ;(async () => {
      if (Schedule?.id) {
        let responce = await dispatch(getNotificationCatalogues(Schedule?.id))
        const filteredArray1 = responce?.CatalogueData?.filter(
          item =>
            item.eventNotificationTemplate &&
            item.eventNotificationTemplate.templateName ===
              'request_for_documents' &&
            item.eventNotificationTemplate.eventNotificationType &&
            item.eventNotificationTemplate.eventNotificationType.name ===
              'WhatsApp'
        )

        if (filteredArray1?.length > 0) {
          setReqDocWhatsapp(filteredArray1[0].eventNotificationTemplate)
        }
        const filteredArray2 = responce?.CatalogueData?.filter(
          item =>
            item.eventNotificationTemplate &&
            item.eventNotificationTemplate.templateName ===
              'Request for Documents' &&
            item.eventNotificationTemplate.eventNotificationType &&
            item.eventNotificationTemplate.eventNotificationType.name ===
              'E-Mail'
        )

        if (filteredArray2?.length > 0) {
          setReqDocEmail(filteredArray2[0].eventNotificationTemplate)
        }
      }
    })()

    return () => {}
  }, [Schedule])

  const [docs, setDocs] = useState([])
  useEffect(() => {
    getRequestDocument()
  }, [])

  useEffect(() => {
    getRoleMetrics(driveId, roleId)
  }, [driveId, roleId])
  const onRequestDocument = async () => {
    let docsPayloadArr = []
    let candidateArr = []
    addressSelectedDocuments?.map(doc => {
      docsPayloadArr.push({
        docId: doc.id,
        docName: doc.document_name,
        mandatory: doc.mandatory,
      })
      return null
    })

    indentitySelectedDocuments?.map(doc => {
      docsPayloadArr.push({
        docId: doc.id,
        docName: doc.document_name,
        mandatory: doc.mandatory,
      })
      return null
    })

    docsPayloadArr.push(...docs)
    candidateIds?.map(candidateId => {
      candidateArr?.push({ id: candidateId })
    })
    let payload = {
      students: candidateArr,
      docs: docsPayloadArr,
    }

    let response = await requestCandidateDocuments(driveId, roleId, payload)

    if (
      response?.status >= 200 &&
      response?.status &&
      response?.status !== 404
    ) {
      let InAppObj = {
        notification: {
          students: [
            {
              ids: candidateIds,
              userIds: [],
              roles: ['Student'],
              issuer: 'corporate',
              createFor: 'student',
              inApp: true,
              body: `Congratulations! You've been shortlisted for the ${rolesMetrics[0]?.roleName} at ${corpData?.name}. Please upload your documents to move forward.`,
              tag: 'Request For Documents',
            },
          ],
        },
      }
      dispatch(sendInAppNotification(InAppObj))
      let docList = docsPayloadArr.map(item => item?.docName).join(',')
      if (reqDocWhatsapp) {
        const final = selectedCandidate?.map(item => {
          return {
            to: isSingleOrBulk
              ? item?.student?.studentPersonalProfile?.phoneNumber
              : item?.studentPersonalProfile?.phoneNumber,
            templateName: 'request_for_documents',
            components: [
              {
                type: 'HEADER',
                parameters: [
                  {
                    type: 'IMAGE',
                    image: {
                      link: 'https://drive.google.com/uc?export=view&id=1do69IcSSUj3P6gX202Af8YUF6eCUv5XH',
                    },
                  },
                ],
              },
              {
                type: 'BODY',
                index: 0,
                sub_type: 'CATALOG',
                parameters: [
                  {
                    type: 'TEXT',
                    text: isSingleOrBulk
                      ? item?.student?.firstName
                      : item?.firstName,
                  },
                  {
                    type: 'TEXT',
                    text: rolesMetrics[0]?.roleName,
                  },
                  {
                    type: 'TEXT',
                    text: corpData?.name,
                  },

                  {
                    type: 'TEXT',
                    text: `${STD_APP_URL}/offerReceived`,
                  },
                  {
                    type: 'TEXT',
                    text: docList,
                  },
                ],
              },
            ],
          }
        })
        dispatch(sendNotificationBulkEmailWhatsapp(final))
      }
      if (reqDocEmail) {
        const final = selectedCandidate?.map(item => {
          const template = reqDocEmail?.templateText
            .replace('{companyName}', corpData?.name)
            .replace('{roleName}', rolesMetrics[0]?.roleName)
            .replace('{documentsList}', docList)
            .replaceAll('{insertLink}', `${STD_APP_URL}/offerReceived`)

          return {
            to: isSingleOrBulk
              ? item?.student?.studentPersonalProfile?.primaryEmail
              : item?.studentPersonalProfile?.primaryEmail,
            subject: reqDocEmail?.subject,
            htmlBody: template,
          }
        })
        dispatch(sendNotificationBulkEmail(final))
      }
      setConfirmDrawer(true)
      setDocs([])
      setAddressSelectedDocuments([])
      setIndentitySelectedDocuments([])
      setSelectedCandidateId([])
      setOnAddressMandatory(false)
      setOnIdentityMandatory(false)
      setSelectedDocuments([])
      setSelectedDocType(null)
      setReqestDocumentDrawer(false)
    } else {
      ErrorMessage(response?.response?.data?.message)
    }
  }
  const onClose = () => {
    setReqestDocumentDrawer(false)
  }
  const onChange = doc => checked => {
    if (checked) {
      setDocs(prevDocs => [
        ...prevDocs,
        {
          docId: doc.id,
          docName: doc.document_name,
          mandatory: false,
        },
      ])
    } else {
      setDocs(prevDocs => prevDocs.filter(prevDoc => prevDoc.docId !== doc.id))
    }
  }

  const onMandatoryChange = doc => checked => {
    const docIndex = docs.findIndex(prevDoc => prevDoc.docId === doc.id)

    if (docIndex !== -1) {
      setDocs(prevDocs =>
        prevDocs.map((doc, index) =>
          index === docIndex ? { ...doc, mandatory: checked } : doc
        )
      )
    } else {
      setDocs(prevDocs => [
        ...prevDocs,
        {
          docId: doc.id,
          docName: doc.document_name,
          mandatory: checked,
        },
      ])
    }
  }

  const onCloseDocDetailsDrawer = () => {
    setShowUploadDetailsDrawer(false)
    setSelectedDocType(null)
  }

  const handleClick = value => {
    setShowUploadDetailsDrawer(true)
    setSelectedDocType(value || null)
    const addressDocuments =
      requestDocumentList?.filter(item => item.doc_type === value) || []
    setSelectedDocuments(addressDocuments)
  }

  const onAddressSwitchChange = checked => {
    setIsAddressSwitchOn(checked)
    if (!checked) {
      setOnAddressMandatory(checked)
    }

    setAddressSelectedDocuments([])
  }
  const onIdentityProofSwitchChange = checked => {
    setIsIdentityProofSwitchOn(checked)
    if (!checked) {
      setOnIdentityMandatory(checked)
    }
    setIndentitySelectedDocuments([])
  }

  const handleDocumentSelection = (selectedDocType, selectedDocs) => {
    if (selectedDocType === 'ADDRESS') {
      setAddressSelectedDocuments(selectedDocs)
    } else {
      setIndentitySelectedDocuments(selectedDocs)
    }
  }

  const onAddressMandatorySwitchChange = checked => {
    setOnAddressMandatory(checked)
    const updatedData = addressSelectedDocuments?.map(item => ({
      ...item,
      mandatory: checked,
    }))
    setAddressSelectedDocuments(updatedData)
  }
  const onIdentityMandatorySwitchChange = checked => {
    setOnIdentityMandatory(checked)
    const updatedData = indentitySelectedDocuments?.map(item => ({
      ...item,
      mandatory: checked,
    }))
    setIndentitySelectedDocuments(updatedData)
  }

  const getDocumentLabel = label => {
    switch (label) {
      case 'EDUCATION':
        return 'Education'
      case 'ADDRESS':
        return 'Address'
      case 'IDENTITY_PROOF':
        return 'Identity Proof'
      case 'EMPLOYMENT_PROOF':
        return 'Employment Proof'
      case 'OTHER_DOCUMENT':
        return 'Other Document'
      default:
        break
    }
  }
  const handleEditIconClick = value => {
    setSelectedDocType(value || null)

    setShowUploadDetailsDrawer(true)
  }

  const content = () => {
    return (
      <>
        <TopHeader>
          <HeaderItem>
            <LeftHeaderItem>Documents</LeftHeaderItem>
            <HeaderRightItem>
              <RightHeaderItem>Required</RightHeaderItem>
              <RightHeaderItem>Mandatory</RightHeaderItem>
            </HeaderRightItem>
          </HeaderItem>
          <Divider />
        </TopHeader>
        <div>
          <div>
            {requestDocumentList?.map(section => {
              let showElseContent = false

              return (
                <div key={section.doc_type}>
                  {section.doc_type === 'ADDRESS' ||
                  section.doc_type === 'IDENTITY_PROOF' ? null : (
                    <SubHeaderItem>
                      {getDocumentLabel(section.doc_type)}
                    </SubHeaderItem>
                  )}
                  {section.data.map(item => {
                    if (
                      section.doc_type !== 'ADDRESS' &&
                      section.doc_type !== 'IDENTITY_PROOF'
                    ) {
                      const docExists = docs.some(doc => doc.docId === item.id)
                      const isMandatory = docs.some(
                        doc => doc.docId === item.id && doc.mandatory === true
                      )

                      return (
                        <SubContent key={item.id}>
                          <SubPara>{item.document_name}</SubPara>
                          <Switch
                            onChange={onChange(item)}
                            checked={docExists}
                          />
                          <Switch
                            onChange={onMandatoryChange(item)}
                            checked={isMandatory}
                          />
                        </SubContent>
                      )
                    } else {
                      if (!showElseContent) {
                        showElseContent = true
                        return (
                          <div key={item.id}>
                            {(showElseContent &&
                              section.doc_type === 'ADDRESS') ||
                            section.doc_type === 'IDENTITY_PROOF' ? (
                              <>
                                {section.doc_type === 'ADDRESS' && (
                                  <ListHead>
                                    <SubHeaderItem>
                                      {'Address/Identity Proof'}
                                    </SubHeaderItem>
                                  </ListHead>
                                )}
                                <LisSubtHead>
                                  <SubPara>
                                    {section.doc_type === 'ADDRESS'
                                      ? 'Address Proof'
                                      : 'Identity Proof'}
                                  </SubPara>
                                  <div style={{ display: 'contents' }}>
                                    {section.doc_type === 'ADDRESS' ? (
                                      <>
                                        <Switch
                                          defaultChecked={isAddressSwitchOn}
                                          onChange={onAddressSwitchChange}
                                        />
                                        <Switch
                                          disabled={isAddressSwitchOn === false}
                                          checked={onAddressMandatory}
                                          onChange={
                                            onAddressMandatorySwitchChange
                                          }
                                        />
                                      </>
                                    ) : (
                                      <>
                                        <Switch
                                          defaultChecked={
                                            isIdentityProofSwitchOn
                                          }
                                          onChange={onIdentityProofSwitchChange}
                                        />
                                        <Switch
                                          disabled={
                                            isIdentityProofSwitchOn === false
                                          }
                                          checked={onIdentityMandatory}
                                          onChange={
                                            onIdentityMandatorySwitchChange
                                          }
                                        />
                                      </>
                                    )}
                                  </div>
                                </LisSubtHead>
                                <br />
                                {section.doc_type === 'ADDRESS' &&
                                  isAddressSwitchOn &&
                                  (addressSelectedDocuments &&
                                  addressSelectedDocuments.length > 0 ? (
                                    <CheckboxItem>
                                      <div
                                        style={{
                                          display: 'flex',
                                          textTransform: 'capitalize',
                                        }}
                                      >
                                        {`(${addressSelectedDocuments
                                          .map(doc => doc.document_name)
                                          .join(' / ')})`}
                                      </div>
                                      <IconPointer
                                        onClick={() =>
                                          handleEditIconClick('ADDRESS')
                                        }
                                      >
                                        <EditIcon />
                                      </IconPointer>
                                    </CheckboxItem>
                                  ) : (
                                    <ListItem>
                                      <ParaText>No documents added</ParaText>
                                      <DrivesButton
                                        height={'33px'}
                                        weight={'80px'}
                                        fontWeight={'600'}
                                        text={'Add Documents '}
                                        onClick={() => handleClick('ADDRESS')}
                                      />
                                    </ListItem>
                                  ))}

                                {section.doc_type === 'IDENTITY_PROOF' &&
                                  isIdentityProofSwitchOn &&
                                  (indentitySelectedDocuments.length > 0 ? (
                                    <CheckboxItem>
                                      <div
                                        style={{
                                          display: 'flex',
                                          textTransform: 'capitalize',
                                        }}
                                      >
                                        {`(${indentitySelectedDocuments
                                          .map(doc => doc.document_name)
                                          .join(' / ')})`}
                                      </div>
                                      <IconPointer
                                        onClick={() =>
                                          handleEditIconClick('IDENTITY_PROOF')
                                        }
                                      >
                                        <EditIcon />
                                      </IconPointer>
                                    </CheckboxItem>
                                  ) : (
                                    <ListItem>
                                      <ParaText>No documents added</ParaText>
                                      <DrivesButton
                                        height={'33px'}
                                        weight={'80px'}
                                        fontWeight={'600'}
                                        text={'Add Documents '}
                                        onClick={() =>
                                          handleClick('IDENTITY_PROOF')
                                        }
                                      />
                                    </ListItem>
                                  ))}
                              </>
                            ) : null}
                          </div>
                        )
                      }
                      return null
                    }
                  })}
                  {section.doc_type === 'ADDRESS' ? (
                    <StyledDivider isAddress={true} />
                  ) : (
                    <StyledDivider />
                  )}
                </div>
              )
            })}
          </div>
        </div>
      </>
    )
  }

  const footer = () => {
    return (
      <FooterFlex flexEnd>
        <Button.Secondary height="38px" text="Cancel" onClick={onClose} />
        <Button.Primary
          height="38px"
          text="Request"
          onClick={onRequestDocument}
        />
      </FooterFlex>
    )
  }

  return (
    <>
      <CustomStyledDrawer
        width="40%"
        title={'Request Document'}
        placement="right"
        visible={reqestDocumentDrawer}
        content={content()}
        footer={footer()}
        onClose={onClose}
        closable
      />
      {showUploadDetailsDrawer && (
        <UploadDetailsDrawer
          selectedDocType={selectedDocType}
          onClose={onCloseDocDetailsDrawer}
          setSelectedDocType={setSelectedDocType}
          updateSelectedDocuments={handleDocumentSelection}
          selectedDocuments={selectedDocuments}
          requestDocumentList={requestDocumentList}
          onAddressMandatory={onAddressMandatory}
          addressSelectedDocuments={addressSelectedDocuments}
          indentitySelectedDocuments={indentitySelectedDocuments}
        />
      )}
      <ConfirmDrawer
        conformDrawer={confirmDrawer}
        setConfirmDrawer={setConfirmDrawer}
      />
    </>
  )
}

export default RequestDocumentdrawer
